import axios from 'axios';
import Service from '@advisor/util/Service';

const {MS_BASE} = Service;

export default class Client {
  /**
   * This Api is used to delete the client goal that is not attached to either open or pending accounts.
   * This api soft deletes the goal from CL_goal.
   */
  static deleteClientGoal(goalId, riaId) {
    return axios.delete(`${MS_BASE}/v1/client/goals/${goalId}?riaId=${riaId}`);
  }

  /**
   * Get account details of existing account
   * @param {accountId} params account id
   */
  static getAccountDetails({accountId}) {
    return axios.get(`${MS_BASE}/v1/client/account/summary/${accountId}`);
  }
}
